<div class="master-container">
  <div class="titolo"> Contenuto del corso </div>
  <div *ngIf="mimetype.includes('pdf')">
    <table>
      <tr>
        <td>
          <div *ngIf="pdfData" class="container-fluid h-100 w-50">
            <button mat-mini-fab (click)="previousPage()">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <button mat-mini-fab (click)="nextPage()">
                <mat-icon>chevron_right</mat-icon>
            </button>
            <button mat-mini-fab (click)="plusZoom()">
                <mat-icon>zoom_in</mat-icon>
            </button>
            <button mat-mini-fab (click)="minusZoom()">
                <mat-icon>zoom_out</mat-icon>
            </button>
            <button mat-mini-fab (click)="rotatedx()">
                <mat-icon>rotate_right</mat-icon>
            </button>
            <button mat-mini-fab (click)="rotatesx()">
                <mat-icon>rotate_left</mat-icon>
            </button>
          </div>
        </td>
      </tr>
    </table>
    <div class="container-fluid w-75">
      <div *ngIf="pdfData">
        <pdf-viewer   [src]="pdfData"
                      [show-all]="false"
                      [(page)]="pageVariable"
                      [render-text]="true"
                      [zoom]="zoom"
                      [rotation]="angle"
                      [show-borders]="true"
                      (error)="errorTest($event)"
                      [original-size]="false"
                      (after-load-complete)="afterLoadComplete($event)"
                      (page-rendered)="pageRendered($event)"
                      (text-layer-rendered)="textLayerRendered($event)"
                      style="width=1000px; height: 750px">
        </pdf-viewer>
      </div>
 <!--     <div *ngIf="streamUrl && mimetype.includes('pdf')">
        <iframe [src]="streamUrl" width="100%" height="750px" style="border: none;"></iframe>
      </div>-->
    </div>
  </div>
  <div *ngIf="mimetype.includes('video')">
    <video controls height="600" width="100%" #videoPlayer>
      <source [src]="streamUrl ? streamUrl : srcvideo" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  </div>
</div>
